import React, { useState } from "react";
import axios from "axios";

interface Props {
  onClose: () => void;
  fetchBanners: () => void;
  editingBanner?: any;
}

export default function BannerFormModal({
  onClose,
  fetchBanners,
  editingBanner,
}: Props) {
  const [heading, setHeading] = useState(editingBanner?.heading || "");
  const [description, setDescription] = useState(
    editingBanner?.description || ""
  );
  const [file, setFile] = useState<File | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("heading", heading);
    formData.append("description", description);
    if (file) formData.append("bannerImage", file);

    try {
      if (editingBanner) {
        await axios.patch(
          `${process.env.REACT_APP_LOCAL_URL}/api/banner-data/${editingBanner._id}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
      } else {
        await axios.post(`${process.env.REACT_APP_LOCAL_URL}/api/banner-data`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }

      fetchBanners();
      onClose();
    } catch (error) {
      console.error("Error saving banner:", error);
    }
  };

  return (
    <div className="fixed inset-0 flex justify-center items-center bg-black/40 z-50">
      <div className="bg-white p-6 rounded-xl w-[450px] shadow-lg">
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Heading */}
          <label htmlFor="heading" className="block font-lato-bold mt-4">
            Heading
          </label>
          <input
            type="text"
            placeholder="Heading"
            value={heading}
            onChange={(e) => setHeading(e.target.value)}
            required
            className="w-full border border-gray-300 rounded-md p-2"
          />

          {/* Description */}
          <label htmlFor="description" className="block font-lato-bold mt-4">
            Description
          </label>
          <textarea
            placeholder="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
            className="w-full border border-gray-300 rounded-md p-2 h-24"
          />

          {/* Image Upload + Preview */}
          <label htmlFor="bannerImage" className="block font-lato-bold mt-4">
            {editingBanner ? "Update Image (optional)" : "Upload Image"}
          </label>

          {/* Show existing image preview if editing */}
          {editingBanner?.bannerImage && !file && (
            <div className="mb-2">
              <img
                src={`${process.env.REACT_APP_LOCAL_URL}/${editingBanner.bannerImage}`}
                alt="Current Banner"
                className="w-full h-40 object-cover rounded-md border"
              />
              <p className="text-sm text-gray-500 mt-1 text-center">
                Current Image Preview
              </p>
            </div>
          )}

          {/* File input */}
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setFile(e.target.files?.[0] || null)}
            className="w-full border border-gray-300 rounded-md p-2"
          />

          <div className="flex justify-end gap-3 mt-6">
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
            >
              {editingBanner ? "Update" : "Upload"}
            </button>
            <button
              type="button"
              onClick={onClose}
              className="text-red-500 border border-red-500 px-4 py-2 rounded-md hover:bg-red-50"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
